import { useState } from "react";
import { Form } from "react-bootstrap";
import { update } from "./services/upload-files.service";

const EditPersonalInformation = ({ activeTab, handleInputChange, formData, setLoading, setFormData, userdetails }) => {
    const [validationErrors, setValidationErrors] = useState({});

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateFormFields(formData);
        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
        } else {
            try {
                setLoading(true)
                let fData = new FormData();

                // Append objects as JSON strings
                fData.append("user", JSON.stringify(formData.user));
                fData.append("personal_info", JSON.stringify(formData.personal_info));
                fData.append("company_info", JSON.stringify(formData.company_info));

                const res = await update(fData, `users/profile/${userdetails.id}`);
                if (res && res.success) {

                    setValidationErrors({ success: 'Successfully Registered' });
                    setLoading(false)
                    setFormData(res);
                } else {
                    setValidationErrors({ err: 'Please Enter a Valid Information' });
                }
            } catch (error) {
                setValidationErrors({ err: 'An Error Occurred. Please Try Again Later.' });
            }
            // setFormData({});
        }
    };

    const validateFormFields = (formData) => {
        const errors = {};

        // Helper functions
        const isAlphabetic = (str) => str.split('').every(char => /^[a-zA-Z\s]+$/.test(char));
        const isNumeric = (str) => str.split('').every(char => /^\d+$/.test(char));
        const isLength = (str, length) => str.length === length;


        // Personal Information validation
        if (!formData.personal_info || !formData.personal_info.firstname || formData.personal_info.firstname.trim() === "") {
            errors.personal_info = { ...errors.personal_info, firstname: "Please Enter First Name" };
        } else if (!isAlphabetic(formData.personal_info.firstname)) {
            errors.personal_info = { ...errors.personal_info, firstname: "First Name Should Contain Only Letters" };
        }

        if (!formData.personal_info || !formData.personal_info.lastname || formData.personal_info.lastname.trim() === "") {
            errors.personal_info = { ...errors.personal_info, lastname: "Please Enter Last Name" };
        } else if (!isAlphabetic(formData.personal_info.lastname)) {
            errors.personal_info = { ...errors.personal_info, lastname: "Last Name Should Contain Only Letters" };
        }

        if (!formData.personal_info || !formData.personal_info.mobile || formData.personal_info.mobile.trim() === '') {
            errors.personal_info = { ...errors.personal_info, mobile: 'Please Enter a Contact Number' };
        } else if (!isNumeric(formData.personal_info.mobile) || !isLength(formData.personal_info.mobile, 10)) {
            errors.personal_info = { ...errors.personal_info, mobile: "Please Enter a Valid Contact Number" };
        }

        if (!formData.personal_info || !formData.personal_info.city || formData.personal_info.city.trim() === '') {
            errors.personal_info = { ...errors.personal_info, city: 'Please Enter a City' };
        } else if (!isAlphabetic(formData.personal_info.city)) {
            errors.personal_info = { ...errors.personal_info, city: "City Should Contain Only Letters" };
        }

        if (!formData.personal_info || !formData.personal_info.state || formData.personal_info.state.trim() === '') {
            errors.personal_info = { ...errors.personal_info, state: 'Please Enter a State' };
        } else if (!isAlphabetic(formData.personal_info.state)) {
            errors.personal_info = { ...errors.personal_info, state: "State Should Contain Only Letters" };
        }

        if (!formData.personal_info || !formData.personal_info.country || formData.personal_info.country.trim() === '') {
            errors.personal_info = { ...errors.personal_info, country: 'Please enter a Country' };
        } else if (!isAlphabetic(formData.personal_info.country)) {
            errors.personal_info = { ...errors.personal_info, country: "Country Should Contain Only Letters" };
        }

        if (!formData.personal_info || !formData.personal_info.pin || formData.personal_info.pin.trim() === '') {
            errors.personal_info = { ...errors.personal_info, pin: 'Please Enter a Pin' };
        } else if (!isNumeric(formData.personal_info.pin) || !isLength(formData.personal_info.pin, 6)) {
            errors.personal_info = { ...errors.personal_info, pin: "Please Enter a Valid Pincode" };
        }

        return errors;
    };

    return (
        <>
            <div
                className={`tab-pane fade ${activeTab === 'personal-information' ? 'show active' : ''}`}
                id="nav-employee"
                role="tabpanel"
                aria-labelledby="nav-employee-tab"
            >
                {/* <EmployeeMaster /> */}
                <div className='row'>
                    <div className='col-4'>
                        <div className='editprofile'>
                            {/* <h4>Personal Information</h4> */}
                            {/* <hr></hr> */}

                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="fname">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="personal_info__firstname"
                                        value={formData.personal_info ? formData.personal_info.firstname || '' : ''}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.personal_info && <div className="error login-error">{validationErrors.personal_info.firstname}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="lname">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="personal_info__lastname"
                                        value={formData.personal_info ? formData.personal_info.lastname || '' : ''}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.personal_info && <div className="error login-error">{validationErrors.personal_info.lastname}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="cno">
                                    <Form.Label>Contact no</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="personal_info__mobile"
                                        value={formData.personal_info ? formData.personal_info.mobile || '' : ''}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.personal_info && <div className="error login-error">{validationErrors.personal_info.mobile}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="city">
                                    <Form.Label>City</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="personal_info__city"
                                        value={formData.personal_info ? formData.personal_info.city || '' : ''}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.personal_info && <div className="error login-error">{validationErrors.personal_info.city}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="state">
                                    <Form.Label>State</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="personal_info__state"
                                        value={formData.personal_info ? formData.personal_info.state || '' : ''}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.personal_info && <div className="error login-error">{validationErrors.personal_info.state}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="country">
                                    <Form.Label>Country</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="personal_info__country"
                                        value={formData.personal_info ? formData.personal_info.country || '' : ''}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.personal_info && <div className="error login-error">{validationErrors.personal_info.country}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="pcode">
                                    <Form.Label>Pincode</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="personal_info__pin"
                                        value={formData.personal_info ? formData.personal_info.pin || '' : ''}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.personal_info && <div className="error login-error">{validationErrors.personal_info.pin}</div>}
                                </Form.Group>
                                <button class="btn btn-primary btn-add mb-3" type='submit'>  Save</button>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default EditPersonalInformation;